import { Delete } from '@material-ui/icons';
import {
  Column,
  Columns,
  Inline,
  OverflowText,
  Stack,
} from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { ErrorIcon } from 'shared/icons/ErrorIcon';
import { ButtonBase, Typography } from '@material-ui/core';
import { IconWrapper } from './FileListItem';
import { RejectedImportFile } from './LoadsImportSnackbar';

interface RejectedFileListItemProps {
  rejectedFile?: RejectedImportFile;
  onRemove: (file: File) => void;
}

export function RejectedFileListItem({
  rejectedFile,
  onRemove,
}: RejectedFileListItemProps) {
  return (
    <Stack space="xsmall">
      <Columns space="xsmall">
        <Column width="fluid">
          <Columns space="xsmall" align="top">
            <Column width="content">
              <IconWrapper>
                <ErrorIcon fontSize="small" color="error" />
              </IconWrapper>
            </Column>
            <Column width="fluid">
              <OverflowText disableUnderline={true} variant="body1">
                {rejectedFile?.file.name}
              </OverflowText>
            </Column>
          </Columns>
        </Column>
        <Column width="content">
          <Box paddingRight="small">
            <Inline horizontalAlign="right">
              <ButtonBase
                title="Delete"
                onClick={() => {
                  onRemove(rejectedFile?.file as File);
                }}
              >
                <Delete fontSize="small" color="action" />
              </ButtonBase>
            </Inline>
          </Box>
        </Column>
      </Columns>

      {rejectedFile?.errors.map((error, index) => (
        <Typography key={index} color="error">
          {error.message}
        </Typography>
      ))}
    </Stack>
  );
}
